import $ from 'jquery';

const buttons = document.querySelectorAll('.video-library-language-button');
buttons.forEach((button) => {
  button.addEventListener('click', function (event) {
    event.stopPropagation();
    const card = button.closest('article');
    const allButtonsInCard = card.querySelectorAll(
      '.video-library-language-button'
    );
    const altTitle = card.dataset.altTitle;
    const title = card.querySelector('h4').textContent;

    allButtonsInCard.forEach((btn) => {
      btn.classList.toggle('active');
    });

    const id = card.id.split('_')[1];
    const iframe = document.querySelector(`iframe#video_${id}`);
    const src = iframe.src;
    const newSrc = iframe.dataset.altSrc;

    // switch iframe src and alt-src
    if (newSrc) {
      iframe.src = newSrc;
      iframe.dataset.altSrc = src;
      card.dataset.altTitle = title;
      card.querySelector('h4').textContent = altTitle;
    }
  });
});

// Stop video when modal is closed
const modal = $('.modal');
modal.on('modal:beforeHide', (event) => {
  console.log('modal:beforeHide');
  console.log(event);
  // rebuild iframe with same src to stop video
  const iframes = document.querySelectorAll('iframe');
  iframes.forEach((iframe) => {
    const src = iframe.src;
    iframe.src = '';
    // set iframe src back to original src
    iframe.src = src;
  });
});
